<template>
  <div class="button-options-setting-active-and-hover">
    <!--<div v-if="mouseType === 'hover'" class="setting-item">-->
      <!--<el-checkbox class="paddingl54 mb12 mt8" v-model="hoverIsSameActive">同选中状态</el-checkbox>-->
    <!--</div>-->
    <template v-if="(mouseType === 'hover' && !hoverIsSameActive) || mouseType === 'active'">
      <el-collapse v-model="activeNames" style="width: 100%">
        <el-collapse-item title="文字" name="1">
          <div class="setting-item clearFloat">
            <text-setting-complex-update
              :fontFamily.sync="fontFamily"
              :fontSize.sync="fontSize"
              :fontWeight.sync="fontWeight"
              :fontStyle.sync="fontStyle"
              :textDecoration.sync="textDecoration"
              :lineHeight.sync="lineHeight"
              :letterSpacing.sync="letterSpacing"
              :activeArrangement.sync="activeArrangement"
              :writingMode.sync="writingMode"
              :textAlign.sync="textAlign"
              :showTextAlignSetting="true"
              :activeArrangementOrder.sync="activeArrangementOrder"
              :lineHeightType.sync="lineHeightType"
              :letterSpacingType.sync="letterSpacingType"
              :showTextShadowSetting="false"
              :isThemeColor.sync="textIsThemeColor"
              :colorArr.sync="colorArr"
              :activeNameColor.sync="activeNameColor"
              :showOverflowSetting="true"
              :contentHasLimit.sync="contentHasLimit"
              :contentHasLimitRadio="'字数'"
              :textLimitWords.sync="textLimitLines"
              :overflowTypes="['字数', '无']"
              :options="options"
            />
          </div>
          <div></div>
        </el-collapse-item>
        <el-collapse-item title="背景" name="2">
          <cx-background infoTips="支持上传图片" :background.sync="background" imgType="10" :options="options" />
        </el-collapse-item>
        <el-collapse-item title="图标" name="3">
          <div class="content-item verticallyCenter">
            <el-checkbox v-model="showIcon">显示图标</el-checkbox>
          </div>
          <div v-if="showIcon" class="content-item mt8">
            <img-icon-upload
              class="mb16"
              :imgSrc.sync="iconSrc"
              :iconType.sync="iconType"
              :iconColor.sync="iconColor"
              :resInfo.sync="resInfo"
            />
            <div v-show="iconSrc.length" class="content-item mb16 verticallyCenter">
              <span class="mr16 fs14">位置</span>
              <el-radio-group v-model="iconPosition">
                <el-radio label="left">左</el-radio>
                <el-radio label="right">右</el-radio>
                <el-radio label="top">上</el-radio>
                <el-radio label="bottom">下</el-radio>
              </el-radio-group>
            </div>
            <div class="verticallyCenter mb16" v-if="iconType === 'icon'">
              <span class="mr16 fs14">颜色</span>
              <cx-color-picker class="flex1" :isThemeColor.sync="iconColorIsThemeColor" :colorArr.sync="iconColor">
              </cx-color-picker>
            </div>

            <slider-and-input class="mb16" :value.sync="iconWidth" title="大小" :sliderMax="sliderMax" suffix="px" />
            <slider-and-input :value.sync="iconMargin" title="间距" :sliderMax="sliderMax" suffix="px" />
          </div>
        </el-collapse-item>
        <el-collapse-item title="边框" name="4">
          <div>
            <div class="content-item verticallyCenter mb8">
              <el-checkbox v-model="showBorder">显示边框</el-checkbox>
            </div>
            <cx-border
              v-if="showBorder"
              :borderWidth.sync="borderWidth"
              :borderStyle.sync="borderStyle"
              :borderColor.sync="borderColor"
              :borderIsThemeColor.sync="borderIsThemeColor"
            />
          </div>
          <div class="content-item mt16">
            <border-radius
              :borderTypeFlag.sync="borderTypeFlag"
              :borderRadius.sync="borderRadius"
              :borderTopLeftRadius.sync="borderTopLeftRadius"
              :borderTopRightRadius.sync="borderTopRightRadius"
              :borderBottomRightRadius.sync="borderBottomRightRadius"
              :borderBottomLeftRadius.sync="borderBottomLeftRadius"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item title="边距" name="5">
          <div class="setting-item">
            <div class="content">
              <div class="content-item">
                <cx-padding
                  :paddingTypeFlag.sync="paddingTypeFlag"
                  :padding.sync="padding"
                  :paddingTop.sync="paddingTop"
                  :paddingRight.sync="paddingRight"
                  :paddingBottom.sync="paddingBottom"
                  :paddingLeft.sync="paddingLeft"
                />
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="更多" name="6">
          <div class="setting-item">
            <div class="content">
              <div class="content-item mb16">
                <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
              </div>
              <div class="mt16">
                <slider-and-input class="mt8" :value.sync="rotate" title="旋转" :sliderMax="360" suffix="度" />
              </div>
              <div class="content-item mt16">
                <div class="checkbox_colorPicker_container">
                  <span>阴影</span>
                  <span
                    v-show="shadowChecked"
                    class="icon-portal-plus theme-color right-icon"
                    @click="addBoxshadow"
                  ></span>
                </div>
                <box-shadow
                  v-show="shadowChecked"
                  :boxShadowH.sync="boxShadowH"
                  :boxShadowV.sync="boxShadowV"
                  :boxShadowBlur.sync="boxShadowBlur"
                  :boxShadowSpread.sync="boxShadowSpread"
                  :boxShadowColor.sync="boxShadowColor"
                ></box-shadow>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </template>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
import TextSettingComplex from "modules/components/textSettingComplex"
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  name: "button-active-and-hover",
  components: { controlWidthAndSizeAndZindex, widthAndSizeAndZindex, TextSettingComplex },
  props: {
    options: Object,
    mouseType: {
      default: "default",
      type: String
    },
  },
  data() {
    return {
      this1: this,
      activeNames: ["1", "2"],
      shadowChecked: true,
      sliderMax: 360,
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    hoverIsSameActive: {
      get() {
        return this.options.hoverIsSameActive
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverIsSameActive", false)
      }
    },
    width: {
      get() {
        return this.mouseType === "active" ? (this.options.activeWidth || 0) : this.options.hoverWidth || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), this.mouseType + "Width", false)
      }
    },
    height: {
      get() {
        return this.mouseType === "active" ? (this.options.activeHeight || 0) : (this.options.hoverHeight || 0)
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), this.mouseType + "Height", false)
      }
    },
    fontSize: {
      get() {
        return this.mouseType === "active" ? (this.options.activeFontSize || 12) : (this.options.hoverFontSize || 12)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "FontSize", false)
      }
    },
    fontStyle: {
      get() {
        return this.mouseType === "active" ? this.options.activeFontStyle : this.options.hoverFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "FontStyle", false)
      }
    },
    fontWeight: {
      get() {
        return this.mouseType === "active" ? this.options.activeFontWeight : this.options.hoverFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "FontWeight", false)
      }
    },
    lineHeight: {
      get() {
        return this.mouseType === "active" ? this.options.activeLineHeight : this.options.hoverLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "LineHeight", false)
      }
    },
    textDecoration: {
      get() {
        return this.mouseType === "active" ? this.options.activeTextDecoration : this.options.hoverTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "TextDecoration", false)
      }
    },
    color: {
      get() {
        return this.mouseType === "active" ? this.options.activeColor : this.options.hoverColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "Color", false)
      }
    },
    textIsThemeColor: {
      get() {
        return this.mouseType === "active" ? (this.options.activeTextIsThemeColor || false) : (this.options.hoverTextIsThemeColor || false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "TextIsThemeColor", false)
      }
    },
    bgColorIsThemeColor: {
      get() {
        return this.mouseType === "active" ? (this.options.activeBgColorIsThemeColor || false) : (this.options.hoverBgColorIsThemeColor || false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "BgColorIsThemeColor", false)
      }
    },
    background: {
      get() {
        let background = this.mouseType === "active" ? this.options.activeBackground : this.options.hoverBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.mouseType === "active" ? this.activeBgColorIsThemeColor : this.hoverBgColorIsThemeColor,
            color:  this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, this.mouseType + "Background", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "Background", false)
      }
    },
    colorArr: {
      get() {
        let color = this.mouseType === "active" ? this.options.activeColorArr : this.options.hoverColorArr
        if (color && JSON.stringify(color) !== "{}") {
          return color
        }
        let newColor = {
          type: "color",
          label: "颜色",
          isThemeColor: false,
          data: {
            angle: 0,
            stops: [
              [this.options.color, 0],
              [this.options.color, 1]
            ]
          }
        }
        this.$changeOptionsEV(newColor, this.mouseType + "ColorArr", false, false, false, true)
        return newColor
      },
      set(val) {
        this.$changeOptionsEV(val, this.mouseType + "ColorArr", false)
      }
    },
    fontFamily: {
      get() {
        return this.mouseType === "active" ? this.options.activeFontFamily : this.options.hoverFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "FontFamily", false)
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.mouseType === "active" ? Number(this.options.activeBorderTopLeftRadius) : Number(this.options.hoverBorderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "BorderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.mouseType === "active" ? Number(this.options.activeBorderTopRightRadius) : Number(this.options.hoverBorderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "BorderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.mouseType === "active" ? Number(this.options.activeBorderBottomRightRadius) : Number(this.options.hoverBorderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "BorderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.mouseType === "active" ? Number(this.options.activeBorderBottomLeftRadius) : Number(this.options.hoverBorderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "BorderBottomLeftRadius", false)
      }
    },
    borderRadius: {
      get() {
        return this.mouseType === "active" ? Number(this.options.activeBorderBottomLeftRadius) : Number(this.options.hoverBorderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          [this.mouseType + "BorderTopLeftRadius", this.mouseType + "BorderTopRightRadius", this.mouseType + "BorderBottomRightRadius", this.mouseType + "BorderBottomLeftRadius"],
          false
        )
      }
    },
    borderStyle: {
      get() {
        return this.mouseType === "active" ? this.options.activeBorderStyle : this.options.hoverBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "BorderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.mouseType === "active" ? this.options.activeBorderColor : this.options.hoverBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "BorderColor", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        let optionName = this.mouseType === "active" ? "activeBorderTypeFlag" : "hoverBorderTypeFlag"
        if (!this.options.hasOwnProperty(optionName)) {
          if(this.mouseType === "active"){
            if (
                ((this.activeBorderTopLeftRadius === this.activeBorderTopRightRadius) === this.activeBorderBottomLeftRadius) === this.activeBorderBottomRightRadius
            ) {
              defaultType = 2
            }
          } else {
            if (
                ((this.hoverBorderTopLeftRadius === this.hoverBorderTopRightRadius) === this.hoverBorderBottomLeftRadius) === this.hoverBorderBottomRightRadius
            ) {
              defaultType = 2
            }
          }
        }
        return (this.mouseType === "active" ? this.options.activeBorderTypeFlag : this.options.hoverBorderTypeFlag) || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "BorderTypeFlag", false)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        let optionName = this.mouseType === "active" ? this.options.activeShowBorder : this.options.hoverShowBorder
        let optionName2 = this.mouseType === "active" ? this.options.activeBorderWidth : this.options.hoverBorderWidth
        if(optionName === undefined){
          if(optionName2){
            showBorder = true
          }else{
            showBorder = false
          }
        }else{
          showBorder = optionName
        }
        return showBorder
      },
      set(newVal) {
        if(newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], [this.mouseType + "BorderWidth", this.mouseType + "ShowBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, this.mouseType + "ShowBorder", false)
        }
      }
    },
    borderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, this.mouseType + "BorderWidth", this.mouseType + "BorderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "BorderWidth", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.mouseType === "active" ? this.options.activeBorderIsThemeColor : this.options.hoverBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "BorderIsThemeColor", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.mouseType === "active" ? this.options.activeBoxShadowColor : this.options.hoverBoxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "BoxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.mouseType === "active" ? this.options.activeBoxShadowH : this.options.hoverBoxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "BoxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.mouseType === "active" ? this.options.activeBoxShadowV : this.options.hoverBoxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "BoxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.mouseType === "active" ? this.options.activeBoxShadowBlur : this.options.hoverBoxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "BoxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.mouseType === "active" ? this.options.activeBoxShadowSpread : this.options.hoverBoxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "BoxShadowSpread", false)
      }
    },
    // 边距
    paddingTypeFlag: {
      get() {
        let defaultType = 1
        let optionName = this.mouseType === "active" ? "activePaddingTypeFlag" : "hoverPaddingTypeFlag"
        if (!this.options.hasOwnProperty(optionName)) {
          if (this.mouseType === "active" && ((this.activePaddingTop === this.activePaddingRight) === this.activePaddingLeft) === this.activePaddingBottom) {
            defaultType = 2
          }
          if (this.mouseType === "hover" && ((this.hoverPaddingTop === this.hoverPaddingRight) === this.hoverPaddingLeft) === this.hoverPaddingBottom) {
            defaultType = 2
          }
        }
        return (this.mouseType === "active" ? this.options.activePaddingTypeFlag : this.options.hoverPaddingTypeFlag) || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "PaddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return (this.mouseType === "active" ? this.options.activePadding : this.options.hoverPadding) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "Padding", false)
      }
    },
    paddingTop: {
      get() {
        return (this.mouseType === "active" ? this.options.activePaddingTop : this.options.hoverPaddingTop) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "PaddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return (this.mouseType === "active" ? this.options.activePaddingRight : this.options.hoverPaddingRight) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "PaddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return (this.mouseType === "active" ? this.options.activePaddingLeft : this.options.hoverPaddingLeft) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "PaddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return (this.mouseType === "active" ? this.options.activePaddingBottom : this.options.hoverPaddingBottom) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "PaddingBottom", false)
      }
    },
    rotate: {
      get() {
        return this.mouseType === "active" ? parseInt(this.options.activeRotate) : parseInt(this.options.hoverRotate)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "Rotate", false)
      }
    },
    imgSrc: {
      get() {
        return this.mouseType === "active" ? this.options.activeImgSrc : this.options.hoverImgSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "ImgSrc", false)
      }
    },
    clipSize: {
      get() {
        return this.mouseType === "active" ? this.options.activeClipSize : this.options.hoverClipSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "ClipSize", false)
      }
    },
    bgType: {
      get() {
        return this.mouseType === "active" ? this.options.activeBgType : this.options.hoverBgType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "BgType", false)
      }
    },
    repeatType: {
      get() {
        return this.mouseType === "active" ? this.options.activeRepeatType : this.options.hoverRepeatType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "RepeatType", false)
      }
    },
    alignType: {
      get() {
        return this.mouseType === "active" ? this.options.activeAlignType : this.options.hoverAlignType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "AlignType", false)
      }
    },
    activeArrangement() {
      return this.mouseType === "active" ? this.options.activeTextAlign : this.options.hoverTextAlign
    },
    opacity: {
      get() {
        let optionName = this.mouseType === "active" ? "activeOpacity" : "hoverOpacity"
        return this.options.hasOwnProperty(optionName) ? parseInt((this.mouseType === "active" ? this.options.activeOpacity : this.options.hoverOpacity) * 100) : 100
      },
      set(newVal) {
        let optionName1 = this.mouseType === "active" ? this.options.activeOpacity : this.options.hoverOpacity
        // 脏数据处理，不记录。opacity最大为1，历史数据有100的
        if (optionName1 === 100) {
          this.$changeOptionsEV(newVal / 100, this.mouseType + "Opacity", false, false, false, true)
        } else {
          this.$changeOptionsEV(newVal / 100, this.mouseType + "Opacity", false)
        }
      }
    },
    textAlign: {
      get() {
        return (this.mouseType === "active" ? this.options.activeTextAlign : this.options.hoverTextAlign) || 'center'
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "TextAlign", false)
      }
    },
    activeArrangementOrder: {
      get() {
        return {
          label: "竖排文字",
          _class: "icon-portal-text-down1",
          isActive: this.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.writingMode = val
      }
    },
    writingMode: {
      get() {
        return this.mouseType === "active" ? this.options.activeWritingMode : this.options.hoverWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "WritingMode", false)
      }
    },
    letterSpacing: {
      get() {
        return this.mouseType === "active" ? this.options.activeLetterSpacing : this.options.hoverLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "LetterSpacing", false)
      }
    },
    iconPosition: {
      get() {
        return this.mouseType === "active" ? this.options.activeIconPosition : this.options.hoverIconPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "IconPosition", false)
      }
    },
    showIcon: {
      get() {
        let showIcon = false
        let optionName = this.mouseType === "active" ? this.options.activeShowIcon : this.options.hoverShowIcon
        let optionName1 = this.mouseType === "active" ? this.options.clickIconSrc : this.options.hoverIconSrc
        if(optionName === undefined){
          if(optionName1){
            showIcon = true
          }else{
            showIcon = false
          }
        }else{
          showIcon = optionName
        }
        return showIcon
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "ShowIcon", false)
      }
    },
    iconSrc: {
      get() {
        return this.mouseType === "active" ? this.options.clickIconSrc : this.options.hoverIconSrc
      },
      set(newVal) {
        let optionName1 = this.mouseType === "active" ? "clickIconSrc" : "hoverIconSrc"
        this.$changeOptionsEV(newVal, optionName1, false)
      }
    },
    iconType: {
      get() {
        return this.mouseType === "active" ? this.options.activeIconType : this.options.hoverIconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "IconType", false)
      }
    },
    iconWidth: {
      get() {
        return this.mouseType === "active" ? this.options.activeIconWidth : this.options.hoverIconWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "IconWidth", false)
      }
    },
    iconMargin: {
      get() {
        return this.mouseType === "active" ? this.options.activeIconMargin : this.options.hoverIconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "IconMargin", false)
      }
    },
    iconColor: {
      get() {
        return (this.mouseType === "active" ? this.options.activeIconColor : this.options.hoverIconColor) || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "IconColor", false)
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.mouseType === "active" ? this.options.activeIconColorIsThemeColor : this.options.hoverIconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "IconColorIsThemeColor", false)
      }
    },
    contentHasLimit: {
      get() {
        return this.mouseType === "active" ? this.options.activeContentHasLimit : this.options.hoverContentHasLimit
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "ContentHasLimit", false)
      }
    },
    textLimitLines: {
      get() {
        return this.mouseType === "active" ? this.options.activeTextLimitLines : this.options.hoverTextLimitLines
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "TextLimitLines", false)
      }
    },
    activeNameColor: {
      get() {
        return (this.mouseType === "active" ? this.options.activeActiveNameColor : this.options.hoverActiveNameColor) || "first"
      },
      set(val) {
        this.$changeOptionsEV(val, this.mouseType + "ActiveNameColor", false)
      }
    },
    resInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, this.mouseType + "ResInfo", this.mouseType + "ResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "ResInfo", false)
      }
    },
    lineHeightType: {
      get() {
        return (this.mouseType === "active" ? this.options.activeLineHeightType : this.options.hoverLineHeightType) || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "LineHeightType", false)
      }
    },
    letterSpacingType: {
      get() {
        return (this.mouseType === "active" ? this.options.activeLetterSpacingType  : this.options.hoverLetterSpacingType ) || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, this.mouseType + "LetterSpacingType", false)
      }
    },
  },
  methods: {
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    getFocus(event) {
      event.currentTarget.select()
    }
  }
})
</script>

<style scoped>
  .paddingl54{
    padding-left: 54px;
  }
</style>
